import React, { useEffect, useState } from "react";
import { Modal, Button, Typography, Space, Card } from "antd";
import { useTourStore } from "../../store/tourStore";
import { ShopOutlined, AppstoreOutlined } from "@ant-design/icons";
import { apiRequests } from "../../shared/api/api";

const { Title, Text } = Typography;

export const WelcomeTourModal = () => {
    const { isFinished, tourMode, isTourActive, startTour, skipTour } = useTourStore();
    const [isOldAccount, setIsOldAccount] = useState(false);

    useEffect(() => {
        // Если тур уже завершен или активен, не делаем лишних запросов
        if (isFinished || tourMode || isTourActive) return;

        apiRequests.users.getMyPermissions().then((permissionRes) => {
            const currentUserId = permissionRes.data?.user_id;
            if (currentUserId) {
                apiRequests.users.getItems().then((usersRes) => {
                    const currentUser = usersRes.data?.result?.find(
                        (user) => user.id === currentUserId
                    );

                    if (currentUser && currentUser.created_at) {
                        const createdAtMs = currentUser.created_at * 1000;
                        const nowMs = Date.now();
                        const hoursSinceRegistration = (nowMs - createdAtMs) / (1000 * 60 * 60);

                        if (hoursSinceRegistration > 24) {
                            setIsOldAccount(true);
                            skipTour(); // автоматически пропускаем тур для старых аккаунтов
                        }
                    }
                }).catch(err => console.error("Error fetching users for tour check", err));
            }
        }).catch(err => console.error("Error fetching permissions for tour check", err));
    }, [isFinished, tourMode, isTourActive, skipTour]);

    // Показывать только если обучение не завершено, режим еще не выбран и аккаунту <= 24 часов
    const isVisible = !isFinished && !tourMode && !isTourActive && !isOldAccount;

    return (
        <Modal
            title={<Title level={3} style={{ textAlign: "center", marginBottom: 0 }}>Добро пожаловать в TableCRM</Title>}
            open={isVisible}
            closable={false}
            footer={null}
            width={700}
            centered
            maskClosable={false}
        >
            <div style={{ textAlign: "center", marginBottom: 24 }}>
                <Text type="secondary">
                    Для того чтобы настроить систему максимально удобно для вас, выберите вашу основную задачу:
                </Text>
            </div>

            <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <Card
                    hoverable
                    onClick={() => {
                        window.open("https://tablecrm.com", "_blank");
                        startTour("marketplace");
                    }}
                    style={{ borderColor: "#1890ff", borderWidth: 2 }}
                >
                    <Space align="start" size="middle">
                        <ShopOutlined style={{ fontSize: 32, color: "#1890ff", marginTop: 4 }} />
                        <div>
                            <Title level={4} style={{ marginTop: 0 }}>Торговля на маркетплейсе (быстро и точка)</Title>
                            <Text>Узнать как быстро опубликовать товары.</Text>
                            <div>
                                <a href="https://tablecrm.com" target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>Подробнее на сайте</a>
                            </div>
                        </div>
                    </Space>
                </Card>

                <Card
                    hoverable
                    onClick={() => startTour("crm")}
                    style={{ borderColor: "#52c41a", borderWidth: 2 }}
                >
                    <Space align="start" size="middle">
                        <AppstoreOutlined style={{ fontSize: 32, color: "#52c41a", marginTop: 4 }} />
                        <div>
                            <Title level={4} style={{ marginTop: 0 }}>Использование CRM под иные цели</Title>
                            <Text>Увеличьте продажи и наведите порядок в учете вашего бизнеса с помощью полного функционала системы.</Text>
                        </div>
                    </Space>
                </Card>
            </Space>

            <div style={{ textAlign: "center", marginTop: 24 }}>
                <Button type="text" onClick={skipTour}>
                    Пропустить обучение, я сам разберусь
                </Button>
            </div>
        </Modal>
    );
};
